
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import LayerGroup from "./LayerGroup";
import { MapActiveLayer, WMSInfo, WMSLayer } from "../../Map.types";
import { faExternalLinkSquare } from "@fortawesome/free-solid-svg-icons";
import Dropdown from "../../../../components/common/Dropdown";
import { WMSListPresentation } from "./WMSList.types";

import './ExternalWmsLayers.css';


export default function ExternalWmsLayers(props: {
    extraWms: [string, WMSInfo][],
    activeLayers: MapActiveLayer[],
    addLayer: (source: string, group: string, layer: WMSLayer) => void
    anonymousUser: boolean,
    forecastEmbargoActive: boolean,
    forecastDate: string,
}) {
    return (
        <Dropdown toggleButton={
            <button className="btn dropdown-toggle" type="button" aria-expanded="false">
                <FontAwesomeIcon icon={faExternalLinkSquare} />
            </button>
        }>
            {props.extraWms.map(([wmsName, wmsInfo]) => {
                const groups = [];
                for (const [group, layers] of Object.entries(wmsInfo.layers)) {
                    groups.push(
                        <LayerGroup
                            key={wmsName + group}
                            baseWms={wmsInfo}
                            group={group}
                            layers={layers}
                            addLayer={props.addLayer}
                            activeLayers={props.activeLayers}
                            presentation={WMSListPresentation.TEXT}
                            anonymousUser={props.anonymousUser}
                            forecastEmbargoActive={props.forecastEmbargoActive}
                            forecastDate={props.forecastDate}
                            disableMouseEvents={true}
                        />
                    );
                }

                return (
                    <Dropdown toggleButton={
                        <div className="p-2 dropdown-toggle pe-auto" role="button" id={wmsName} aria-expanded="false">
                            {wmsInfo.name}
                        </div>
                    }
                        anchorOrigin={{
                            vertical: 'top',
                            horizontal: 'right',
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'left',
                        }}
                        width="300px">
                        <ul aria-labelledby={wmsName} className="p-0">
                            {groups}
                        </ul>
                    </Dropdown>
                );
            })}
        </Dropdown>
    );
}